import { SWRFetcher } from '@commenda/utils';
import useSWR, { SWRConfiguration } from 'swr';
import { ListJobErrorsResponse, ListJobParams, ListJobsResponse } from './types';

export function getAllJobs({
  params,
  options,
}: {
  params: ListJobParams;
  options?: SWRConfiguration;
}) {
  const query = new URLSearchParams();
  query.append('corporation_id', params.corporation_id.toString());

  if (params.limit) query.append('limit', params.limit.toString());
  if (params.cursor) query.append('cursor', params.cursor);
  if (params.entity) query.append('entity', params.entity);
  if (params.entity_id) query.append('entity_id', params.entity_id);
  if (params.operation) query.append('operation', params.operation);
  if (params.status) query.append('status', params.status);

  const { data, error, isLoading, mutate } = useSWR<ListJobsResponse>(
    `new-sales-tax/jobs?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    ),
    options
  );

  return {
    jobs: data?.data.jobs ?? [],
    totalJobs: data?.data.total_jobs ?? 0,
    cursor: data?.data.cursor,
    isLoading,
    error,
    mutate,
  };
}

export function useAllJobErrors({
  job_id,
  corporation_id,
  limit = 10,
  cursor,
}: {
  job_id: string;
  corporation_id: number;
  limit?: number;
  cursor?: string;
}) {
  const query = new URLSearchParams();
  query.append('corporation_id', corporation_id.toString());

  if (limit) query.append('limit', limit.toString());
  if (cursor) query.append('cursor', cursor);

  const { data, error, isLoading, mutate } = useSWR<ListJobErrorsResponse>(
    `new-sales-tax/jobs/${job_id}/errors?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    jobErrors: data?.data.job_errors ?? [],
    totalJobErrors: data?.data.total_job_errors ?? 0,
    cursor: data?.data.cursor,
    isLoading,
    error,
    mutate,
  };
}
